import React from 'react';

import './cmsUserEdit.css';
import CmsUserForm from '../CmsUserForm';

export function CmsUserEdit() {
    return <CmsUserForm isEdit={true} />;
}
